import api from './HttpService';
import { UOM } from '../configs/ApiActionUrl';

async function getAll(pageOption, sortData, keyword) {
  let query = '';

  if (pageOption) {
    const { page, pageSize } = pageOption;
    if (page !== undefined && pageSize !== undefined) {
      query = `?page=${page + 1}&limit=${pageSize}`;
    }
  }

  if (sortData) {
    const { sortField, sort } = sortData;
    if (sortField && sort) {
      query += `&sort_by=${sortField}&order_by=${sort}`;
    }
  }

  if (keyword) {
    query += `&search_key=${keyword}`;
  }

  try {
    const res = await api.get(UOM.LIST + query);
    return res;
  } catch (error) {
    return error; // Rethrow the error to propagate it further
  }
}

async function add(postData) {
  const res = await api.post(UOM.ADD, postData);
  return res;
}

async function getItem(code) {
  const res = await api.get(`${UOM.EDIT}/${code}`);
  return res;
}

async function update(code, postData) {
  const res = await api.patch(`${UOM.UPDATE}/${code}`, postData);
  return res;
}

async function deleteItem(code) {
  const res = await api.delete(`${UOM.DELETE}/${code}`);
  return res;
}

async function getActiveAll() {
  const res = await api.get(`${UOM.ACTIVE}`);
  return res;
}

const UomService = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveAll
};

export default UomService;
